import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { Typo } from 'uikit/content';
import { createIconComponent } from 'uikit/icons';

import Card from './card';

import styles from '../styles/uikitCardsCardBasic.module.scss';

const CardBasic = ({
  className = '',
  icon = '',
  isExternalLink = false,
  subject = '',
  testId = '',
  title = '',
  to = '',
}) => {
  const IconComponent = createIconComponent({ icon, size: 16, className: styles.icon });

  return (
    <Card
      className={className}
      testId={testId}
      to={to}
      isExternalLink={isExternalLink}
    >
      <div className={styles.content}>
        {icon && (
          <div className={styles.icon}>
            {IconComponent}
          </div>
        )}
        {subject && (
        <Typo
          element="span"
          variant="s01"
          modifier="uppercase"
        >
          {subject}
        </Typo>
        )}
        <Typo
          className={styles.title}
          element="h3"
          variant="d01"
          weight="bold"
        >
          {title}
        </Typo>
      </div>
    </Card>
  );
};

CardBasic.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  subject: PropTypes.string,
  testId: PropTypes.string,
  title: PropTypes.string,
  to: PropTypes.string,
  isExternalLink: PropTypes.bool,
};

export default memo(CardBasic);
